import { Bot } from 'lucide-react';

/** Marks a value an AI set, such as an industry research assigned.
 *  `label` names what the AI did (read aloud); `rationale`, when given, is the tooltip instead. */
export function AiMarker({ rationale, label = 'Assigned by AI research' }: { rationale?: string | null; label?: string }) {
  return (
    <span className="badge badge-neutral ai-marker" aria-label={label} title={rationale || label}>
      <Bot aria-hidden="true" />
      AI
    </span>
  );
}
